import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import VideoGrid from './components/VideoGrid';
import FeatureHighlights from './components/FeatureHighlights';
import ArticleList from './components/ArticleList';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '在线观看',
  url: 'https://www.zaixianguankan.com',
  description: '在线观看无需下载，打开即看。海量高清影视、综艺、纪录片任意选择。',
  sameAs: [
    'https://weibo.com/zaixianguankan',
    'https://www.zhihu.com/org/zaixianguankan',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '在线观看',
  url: 'https://www.zaixianguankan.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.zaixianguankan.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '在线观看 - 随时随地畅享高清内容',
  description: '在线观看无需下载，打开即看。海量高清影视、综艺、纪录片任意选择，支持多终端同步，流畅不卡顿。',
  url: 'https://www.zaixianguankan.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '在线观看',
    url: 'https://www.zaixianguankan.com',
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webpageSchema)}
      </script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryTabs />
        <VideoGrid />
        <FeatureHighlights />
        <ArticleList />
      </main>
      <Footer />
    </>
  );
}